import React, { useEffect, useState } from "react";
import styles from "./Ussd.module.scss";
import { ReactComponent as ContentCopy } from "../../assets/images/content-copy.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Get, Post } from "../../api/client";
import { useDispatch } from "react-redux";
import Label from "../Label/Label";
import CustomSelect from "../input/CustomSelect";
import {
  openLoader,
  closeLoader,
} from "../../redux/actions/loader/loaderActions";
import Button from "../button/Button";
import {
  TrackOrderStatusAction,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";

const Ussd = ({ reference }: any) => {
  const dispatch = useDispatch();

  const [copied, setCopied] = useState(false);
  if (copied) {
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }

  const payload = {
    reference: reference,
    paymentOption: "USSD",
    ussd: {
      bankCode: "",
    },
  };

  const [componentData, setComponentData] = React.useState<any>({
    bankselected: false,
    banklist: [],
    payorderres: {},
    pendingfor5min: false,
  });
  const [selectedBankCode, SetSelectedBankCode] = React.useState<any>("");

  const GetBanks = async () => {
    try {
      dispatch(openLoader('default'));
      const res: any = await Get("payment/banks?paymentmethod=ussd");
      const d = res?.data?.data || [];
      const banks = d.map((x: any) => {
        return { name: x.name, value: x.ussdBankCode };
      });
      setComponentData({
        ...componentData,
        banksloading: false,
        banklist: banks,
      });
      dispatch(closeLoader());
    } catch (err: any) {
      dispatch(closeLoader());
    }
  };

  const HandleInputChange = async (event: any) => {
    try {
      SetSelectedBankCode(event.target.value);
      payload.ussd.bankCode = event.target.value;
      await payOrderAction(payload,'default' , dispatch, (res: any) => {
        setComponentData({
          ...componentData,
          payorderres: res,
        });
      });
    } catch (err: any) {}
  };

  useEffect(() => {
    GetBanks();
  }, []);

  return (
    <div className={styles.container}>
      {componentData?.pendingfor5min ? (
        <PendingPaymentCard paymentmethod="Transfer" />
      ) : (
        <div>
          <div className={styles.bank_input_wrapper}>
            <form className={styles.bank_input_form}>
              {/* <h5>Select your preferred bank</h5> */}
              <Label id="bankBode" value="Select Bank of your choice" />
              <CustomSelect
                label=""
                labelid="bankCode"
                inputName="bankCode"
                inputValue={selectedBankCode}
                handleChange={HandleInputChange}
                selectOption={componentData.banklist}
              />
            </form>
          </div>
          {componentData?.payorderres?.status_code == "00" && (
            <div className={styles.paymentDetails}>
              <div className={styles.code}>
                {componentData?.payorderres?.data?.paymentDetail?.recipientAccount}
                <CopyToClipboard
                  text={
                    componentData?.payorderres?.data?.paymentDetail
                      ?.recipientAccount
                  }
                  onCopy={() => setCopied(true)}
                >
                  <span className={styles.copy}>
                    {copied ? (
                      "Copied!"
                    ) : (
                      <>
                        Copy
                        <ContentCopy />
                      </>
                    )}
                  </span>
                </CopyToClipboard>
              </div>
              <div className={styles.dial}>
                Dial the USSD code above on your mobile phone to complete the
                payment.
              </div>
              <div className={styles.copy_to_clipboard}>
                <Button
                  width="100%"
                  onClick={() =>
                    TrackOrderStatusAction(payload,'default' ,dispatch, undefined)
                  }
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#8E173E",
                  }}
                  value="I’ve sent the money"
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Ussd;
